import React, { Component } from "react";
import PropTypes from "prop-types";

const propTypes = {
  children: PropTypes.node,
};

const defaultProps = {};

class DefaultFooter extends Component {
  render() {
    // eslint-disable-next-line
    const { children, ...attributes } = this.props;

    return (
      <React.Fragment>
        <span>
          &copy; {new Date().getFullYear()}{" "}
          <a href="https://www.nbc.org.kh"> National Bank of Cambodia</a>, All
          Rights Reserved. Email:{" "}
          <a target="_top" href="mailto:bakong@nbc.org.kh">
            bakong@nbc.org.kh
          </a>
        </span>
        {/* Powered by CoreUI for React, URL: https://coreui.io/react */}
      </React.Fragment>
    );
  }
}

DefaultFooter.propTypes = propTypes;
DefaultFooter.defaultProps = defaultProps;

export default DefaultFooter;
